import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { ShieldAlert } from 'lucide-react';

const PermissionDenied = ({ 
    message = "You do not have permission to view this page.",
    statusBadge = "403 Forbidden"
}) => {
    return (
        <Box 
            sx={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'calc(100vh - 160px)',
                bgcolor: '#FBFBFB',
                p: { xs: 2, md: 4 }
            }}
        >
            <Box 
                sx={{
                    width: '100%',
                    maxWidth: '440px',
                    bgcolor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    p: { xs: '28px', md: '36px' },
                    boxShadow: 'none',
                    textAlign: 'center',
                    boxSizing: 'border-box',
                }}
            >
                <Box 
                    sx={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '50%',
                        bgcolor: 'rgba(217, 119, 6, 0.08)',
                        border: '1px solid rgba(217, 119, 6, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 2
                    }}
                >
                    <ShieldAlert size={28} color="#D97706" strokeWidth={1.75} />
                </Box>

                {statusBadge && (
                    <Box sx={{ mb: 1.5 }}>
                        <Chip 
                            label={statusBadge} 
                            size="small"
                            sx={{
                                bgcolor: '#FEF3C7',
                                color: '#92400E',
                                fontWeight: 500,
                                fontSize: '0.725rem',
                                height: 22,
                                borderRadius: '4px',
                                border: '1px solid rgba(217, 119, 6, 0.25)',
                                boxShadow: 'none',
                                '& .MuiChip-label': { px: 1 }
                            }}
                        />
                    </Box>
                )}
                
                <Typography 
                    sx={{ 
                        fontSize: '1.25rem',
                        fontWeight: 600,
                        color: '#1E293B',
                        lineHeight: 1.3,
                        mb: 1
                    }}
                >
                    Access Denied
                </Typography>
                
                <Typography 
                    sx={{ 
                        fontSize: '0.875rem',
                        fontWeight: 400,
                        color: '#64748B',
                        lineHeight: 1.6,
                        maxWidth: '360px',
                        mx: 'auto'
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};

export default PermissionDenied;
